import { FC, ReactNode, PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import { SortDirection } from '@tanstack/react-table';

import { CoreTableHeaderCellBase } from './core-table-header-cell-base.component';
import { CoreSortButton } from './core-sort-button.component';
import { Meta } from './core-table-virtual-row.component';

import { Sort, SortDesc, SortAsc } from '../../../constants/icons.constants';

interface CoreTableHeaderCellProps {
	children: ReactNode;
	sortable: boolean;
	size: number;
	meta?: Meta;
	order: false | SortDirection;
	onToggle?(event: unknown): void;
}

const CoreTableHeaderCellText: FC<PropsWithChildren> = ({ children }) => (
	<Typography
		sx={{ overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 300, color: (theme) => theme.colors.gray }}
	>
		{children}
	</Typography>
);

export const CoreTableHeaderCell: FC<CoreTableHeaderCellProps> = (props) => {
	const { children, sortable, order, onToggle, size, meta } = props;

	return (
		<CoreTableHeaderCellBase sortable={sortable} role="columnheader" size={size} flex={meta?.flex}>
			{sortable ? (
				<CoreSortButton onClick={onToggle} sorted={order !== false} sx={{ maxWidth: '100%', m: 0, p: 0 }}>
					<CoreTableHeaderCellText>{children}</CoreTableHeaderCellText>
					{order === false && <Sort className="svg-sort-icon" />}
					{order === 'asc' && <SortAsc className="svg-sort-icon" />}
					{order === 'desc' && <SortDesc className="svg-sort-icon" />}
				</CoreSortButton>
			) : typeof children === 'string' ? (
				<Box sx={{ maxWidth: '100%', p: 0, fontSize: '0.8rem', cursor: 'default' }}>
					<CoreTableHeaderCellText>{children}</CoreTableHeaderCellText>
				</Box>
			) : (
				children
			)}
		</CoreTableHeaderCellBase>
	);
};
